import { Add } from '@mui/icons-material'
import { Box, Icon, InputAdornment, Typography } from '@mui/material'
import AdxButton from 'components/custom/AdxButton'
import AdxDropdown from 'components/custom/AdxDropdown'
import AdxErrorMessage from 'components/custom/AdxErrorMessage'
import AdxInput from 'components/custom/AdxInput'
import AdxMenuItem from 'components/custom/AdxMenuItem'
import { ErrorMessage, Field, FieldArray } from 'formik'
import React, { useEffect, useState } from 'react'

const CustomDeduction = ({ deductCustomItem, formikProps, setStateChanges }) => {
  const [deductionItemOption, setDeductionItemOption] = useState([])
  const [deductItem, setDeductItem] = useState(false)
  const handleCallDeductionList = () => {
    setDeductionItemOption(deductCustomItem)
  }
  const { values, handleBlur, handleChange, errors, touched } = formikProps
  const { deduct_item } = values
  useEffect(() => {
    if (deduct_item?.length !== 0) {
      setDeductItem(true)
    } else {
      setDeductItem(false)
    }
  }, [deduct_item])
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Typography variant="subtitle1">Additional deductions</Typography>
      {deductItem ? (
        <Box>
          <FieldArray name="deduct_item">
            {({ push, remove, form }) => {
              const { values } = form
              const { deduct_item } = values
              return (
                <Box
                  sx={{
                    p: 1,
                    border: 2,
                    borderColor: 'gray-line.main',
                    borderRadius: '10px',
                  }}
                >
                  {deduct_item?.map((_, index) => (
                    <Box
                      key={index}
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'flex-start',
                        columnGap: 2,
                        padding: 1,
                      }}
                    >
                      <Box sx={{ width: 1 }}>
                        <Field
                          name={`deduct_item.${index}.category_items`}
                          as={AdxDropdown}
                          onFocus={handleCallDeductionList}
                          options={deductionItemOption}
                          onChange={(e) => {
                            handleChange(e)
                            setStateChanges(true)
                          }}
                          errorMessage={
                            <ErrorMessage
                              name={`deduct_item.${index}.category_items`}
                              component={AdxErrorMessage}
                            />
                          }
                          isErrorShown={
                            touched.deduct_item &&
                            errors.deduct_item &&
                            errors.deduct_item[index]?.category_items &&
                            touched.deduct_item[index]?.category_items
                          }
                          onBlur={handleBlur}
                          renderValue={(val) => {
                            if (val.title) {
                              return <Typography>{val.title}</Typography>
                            } else {
                              return <Typography>{val.item}</Typography>
                            }
                          }}
                        >
                          {deductionItemOption?.map((list, id) => (
                            <AdxMenuItem
                              selectedvalue={values.deduct_item[index].category_items}
                              key={id}
                              value={list}
                              disabled={
                                values.deduct_item[index].category_items.id !== list.id &&
                                values.deduct_item.find((el) => el.category_items.id === list.id)
                              }
                            >
                              {list.title}
                            </AdxMenuItem>
                          ))}
                        </Field>
                      </Box>
                      <Box sx={{ display: 'flex', alignItems: 'flex-start', columnGap: 1 }}>
                        <Box>
                          <Field
                            name={`deduct_item.${index}.value`}
                            as={AdxInput}
                            startAdornment={<InputAdornment position="start">RM</InputAdornment>}
                            inputProps={{ min: 0 }}
                            onChange={(e) => {
                              handleChange(e)
                              setStateChanges(true)
                            }}
                            errorMessage={
                              <ErrorMessage
                                name={`deduct_item.${index}.value`}
                                component={AdxErrorMessage}
                              />
                            }
                            isErrorShown={
                              touched.deduct_item &&
                              errors.deduct_item &&
                              errors.deduct_item[index]?.value &&
                              touched.deduct_item[index]?.value
                            }
                            onBlur={handleBlur}
                          />
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', height: '45px' }}>
                          <Icon
                            sx={{ color: 'error.main', cursor: 'pointer' }}
                            onClick={() => {
                              remove(index)
                              setStateChanges(true)
                            }}
                          >
                            remove_circle
                          </Icon>
                        </Box>
                      </Box>
                    </Box>
                  ))}
                  <Box
                    sx={{
                      borderTop: 1,
                      borderColor: 'gray-line.main',
                      p: 0.5,
                    }}
                  >
                    <AdxButton
                      variant={'ghost'}
                      onClick={() => {
                        push({ category_items: '', repeat: 0, value: '' })
                        setStateChanges(true)
                      }}
                      startIcon={<Add />}
                      sx={{
                        width: '100%',
                        pl: 2,
                        display: 'flex',
                        justifyContent: 'flex-start',
                      }}
                    >
                      <Typography sx={{ textDecoration: 'underline' }}>Add deduction</Typography>
                    </AdxButton>
                  </Box>
                </Box>
              )
            }}
          </FieldArray>
        </Box>
      ) : (
        <FieldArray name="deduct_item">
          {({ push }) => {
            const handleDeductItem = () => {
              push({ category_items: '', repeat: 0, value: '' })
              setStateChanges(true)
            }
            return (
              <Box
                sx={{
                  paddingX: 12,
                  paddingY: 3,
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  border: 'dashed',
                  borderColor: 'gray-line.main',
                  borderRadius: '10px',
                  my: 2,
                }}
              >
                <Typography color="light-gray-text.main" textAlign="center" sx={{ mb: 2 }}>
                  You have not added any additional deductions yet
                </Typography>
                <AdxButton variant={'outlined'} onClick={handleDeductItem} startIcon={<Add />}>
                  Add
                </AdxButton>
              </Box>
            )
          }}
        </FieldArray>
      )}
    </Box>
  )
}

export default CustomDeduction
